import actionTypes from "./actionType";
import { config, srcPath } from "@utils/config";
const defaultState = {
  showWelcome: true, //展示欢迎页
  videoData: config[0], //当前展示数据
  videoSrc: srcPath[config[0].path], //视频路径
  videoPlay: false, //是否播放
  videoSpeed: 1, //播放速度
  isShowMenu: false, //是否允许出现菜单栏
  showMenu: false, //是否显示菜单栏
  showMenuTime: 0, //关闭倒计时
  showChoices: 0, //展示选项框0不展示，1显示2退出
  choicesArr: [], //选项列表
  selectChoicesTime: 0, //选择记过倒计时
  pageTag: "home", //home是首页，index是视频播放页，result是结果页
  homeType: "again", //home页的状态again是再次进入result是结束页返回的
  videoFullScreen: false, //视频是否进入全屏状态
  isHuawei: /\huawei/i.test(navigator.userAgent), //是否是华为
  isPlayAudio: true
};
// 尝试自定义video
window.myVideo = document.getElementById("myVideo");
myVideo.src = defaultState.videoSrc;
myVideo.loop = true;
export default (state = defaultState, action) => {
  let copyState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionTypes.SAVE_ATTRINFO:
      copyState[action.data.datatype] = action.data.data;
      break;
    case actionTypes.SAVE_OBJECT:
      copyState = Object.assign(copyState, action.data);
      if ("isPlayAudio" in action.data) {
        myVideo.muted = !action.data.isPlayAudio;
        audioBg.muted = !action.data.isPlayAudio;
        audioBtn.muted = !action.data.isPlayAudio;
      }
      break;
  }

  return copyState;
};
